
const parseString = (input) => {
    return input.replace(/\s+/g, '');
};

export default parseString;